import { render, staticRenderFns } from "./PiecesBlock.vue?vue&type=template&id=2674ca8a&scoped=true&"
import script from "./PiecesBlock.vue?vue&type=script&lang=js&"
export * from "./PiecesBlock.vue?vue&type=script&lang=js&"
import style0 from "./PiecesBlock.vue?vue&type=style&index=0&id=2674ca8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674ca8a",
  null
  
)

export default component.exports